import permission from './permission.directive';
import number from './number.directive';
import copy from './copy.directive';
import fixElButtonFocus from './fixElButtonFocus.directive'

export const directives = {
    install(app) {
        return app.use(permission).use(number).use(copy).use(fixElButtonFocus);
    }
};
